import React, { useEffect, useState } from "react";
import { Modal, TextInput, Button, Group, Stack, Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

const EditMarketingPartnerModal = ({
  opened,
  onClose,
  marketingPartner,
  onSave,
}) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (opened) {
      setName(
        marketingPartner?.marketing_partner_name || marketingPartner?.name || ""
      );
      setError("");
    }
  }, [opened, marketingPartner]);

  const handleSave = async () => {
    if (!name.trim()) {
      setError("Name is required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await onSave({ name: name.trim() });
      onClose();
    } catch (err) {
      setError(err.message || "Failed to update marketing partner");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setName("");
    setError("");
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title="Edit Marketing Partner"
      size="md"
    >
      <Stack gap="md">
        {error && (
          <Alert
            icon={<IconAlertCircle size={16} />}
            color="red"
            variant="light"
          >
            {error}
          </Alert>
        )}

        <TextInput
          label="Name"
          placeholder="Enter name"
          value={name}
          onChange={e => setName(e.target.value)}
          required
          data-autofocus
        />

        <Group justify="flex-end" gap="sm">
          <Button variant="outline" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            loading={loading}
            disabled={!name.trim()}
          >
            Save Changes
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default EditMarketingPartnerModal;
